// showing file info in file input
const fileUploads = document.querySelectorAll('.FormFileUpload')

fileUploads.forEach((uploadField) => {
    uploadField.ariaLive = 'polite'

    uploadField
        .querySelector('.FormFileUpload__Input')
        .addEventListener('change', (e) => {
            const [selectedFile] = e.target.files
            const { name: fileName, size } = selectedFile
            // Convert size in bytes to kilo bytes
            const fileSize = (size / 1000).toFixed(2)
            const fileNameAndSize = `${fileName} - ${fileSize}KB`
            uploadField.querySelector(
                '.FormFileUpload__PostedFile'
            ).textContent = fileNameAndSize

            const fileRemoveBtn = uploadField.querySelector(
                '.FormFileUpload__RemovePostedFile'
            )

            if (e.target.files.length > 0 && !fileRemoveBtn) {
                const removeBtn = createRemoveBtn()
                uploadField.appendChild(removeBtn)

                createEventListnerForRemoveBtn(uploadField)
            } else if (e.target.length > 0) {
                fileRemoveBtn.remove()
            }
        })
})

function createRemoveBtn() {
    const removeBtn = document.createElement('button')
    removeBtn.classList.add('FormFileUpload__RemovePostedFile')
    removeBtn.innerText = 'Fjern'
    return removeBtn
}

function createEventListnerForRemoveBtn(uploadField) {
    uploadField
        .querySelector('.FormFileUpload__RemovePostedFile')
        .addEventListener('click', (e) => {
            const fileInput = uploadField.querySelector(
                '.FormFileUpload__Input'
            )
            fileInput.value = ''
            uploadField.querySelector(
                '.FormFileUpload__PostedFile'
            ).textContent = ''
            uploadField
                .querySelector('.FormFileUpload__RemovePostedFile')
                .remove()
        })
}
